// ── Types du système de grouping dynamique du treeview ───────────────────────

export type GroupingLevel =
  | 'project'
  | 'zone'
  | 'type'
  | 'niveau'
  | 'year'
  | 'month'
  | 'none';

export interface TreeGroupingConfig {
  level1: Exclude<GroupingLevel, 'none'>;  // obligatoire, jamais 'none'
  level2: GroupingLevel;
  level3: GroupingLevel;                   // forcé à 'none' si level2 === 'none'
}

export const DEFAULT_TREE_GROUPING: TreeGroupingConfig = {
  level1: 'project',
  level2: 'zone',
  level3: 'year',
};

export const GROUPING_OPTIONS_L1: Exclude<GroupingLevel, 'none'>[] = [
  'project', 'zone', 'type', 'niveau', 'year', 'month',
];

export const GROUPING_OPTIONS_L2: GroupingLevel[] = [
  'project', 'zone', 'type', 'niveau', 'year', 'month', 'none',
];

export const GROUPING_OPTIONS_L3: GroupingLevel[] = [
  'project', 'zone', 'type', 'niveau', 'year', 'month', 'none',
];

export const GROUPING_LEVEL_LABELS: Record<GroupingLevel, string> = {
  project: 'Project',
  zone:    'Zone',
  type:    'Status',
  niveau:  'Level',
  year:    'Year',
  month:   'Month',
  none:    'None',
};